// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WN7sgV{cursor:pointer;border-style:solid;font-size:16px;padding:12px 20px}.WN7sgV .lddHN6{width:12px;padding-right:6.5px}.mobile .WN7sgV .lddHN6{display:none}.WN7sgV._Zkhp3{font-size:13px;padding:10px 17px}.WN7sgV._Zkhp3 .lddHN6{width:10px}.WN7sgV.XutjYe{border-radius:100px}.WN7sgV.hOLC7t{background-color:transparent}.mobile .WN7sgV{font-size:13px;padding:0;min-width:94px;height:30px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `WN7sgV`,
	"buttonIcon": `lddHN6`,
	"buttonSmall": `_Zkhp3`,
	"buttonRound": `XutjYe`,
	"buttonOutline": `hOLC7t`
};
export default ___CSS_LOADER_EXPORT___;
